import { useEffect, useState } from "react";
import Modal from "react-bootstrap/Modal";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faXmark } from "@fortawesome/free-solid-svg-icons";

import { APISD } from "../../../../../../../../config/apisd";
import ToastError from "../../../../../../../NotificationToast/ToastError";
import ToastSuccess from "../../../../../../../NotificationToast/ToastSuccess";

const initialForm = {
  name_learning: "",
};

export default function ModalTipeUjianAdd(props) {
  const token = localStorage.getItem("token");
  const idUser = localStorage
    .getItem("id_admin")
    ?.replace(/[|&;$%@"<>()+,]/g, "");

  const [form, setForm] = useState(initialForm);
  const [isSubmitting, setIsSubmitting] = useState(false);

  const fetchParams = {
    headers: {
      Authorization: `${token}`,
      "Content-Type": "application/json",
    },
  };

  useEffect(() => {
    if (props.show) {
      setForm(initialForm);
      setIsSubmitting(false);
    }
  }, [props.show]);

  const handleChange = (event) => {
    const { name, value } = event.target;

    setForm((previous) => ({
      ...previous,
      [name]: value,
    }));
  };

  const handleSubmit = async (event) => {
    event.preventDefault();

    if (isSubmitting) {
      return;
    }

    setIsSubmitting(true);

    try {
      const response = await APISD.post(
        "/api/learning-types/store",
        {
          name_learning: form.name_learning.trim(),
          user_id: idUser,
        },
        fetchParams
      );

      if (response?.status === 200 || response?.status === 201) {
        ToastSuccess.fire({
          icon: "success",
          title:
            response?.data?.message ||
            "Data tipe ujian berhasil ditambahkan",
        });

        await props.GetResponseData?.();
        props.onHide?.();
      }
    } catch (error) {
      ToastError.fire({
        icon: "error",
        title:
          error?.response?.data?.message ||
          "Gagal menambahkan data tipe ujian",
      });
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <Modal
      {...props}
      centered
      backdrop="static"
      keyboard={false}
      dialogClassName="module-modal-dialog"
      contentClassName="module-modal-content"
    >
      <form onSubmit={handleSubmit}>
        <div className="module-modal-header">
          <div>
            <h5 className="module-modal-title">Tambah Tipe Ujian</h5>
            
          </div>

          <button
            type="button"
            className="module-modal-close"
            onClick={props.onHide}
            disabled={isSubmitting}
            aria-label="Tutup modal"
          >
            <FontAwesomeIcon icon={faXmark} />
          </button>
        </div>

        <Modal.Body className="module-modal-body  mt-2 mx-2">
          <div className="module-form-grid">
            <div className="module-form-group module-form-span-2">
              <label
                className="module-form-label"
                htmlFor="add-name-learning"
              >
                Tipe Ujian <span>*</span>
              </label>

              <input
                id="add-name-learning"
                className="module-form-input"
                type="text"
                name="name_learning"
                value={form.name_learning}
                onChange={handleChange}
               
                autoComplete="off"
                required
              />
            </div>
          </div>
        </Modal.Body>

        <div className="module-modal-footer">
          <button
            type="button"
            className="module-modal-cancel"
            onClick={props.onHide}
            disabled={isSubmitting}
          >
            Batal
          </button>

          <button
            type="submit"
            className="module-modal-submit"
            disabled={isSubmitting}
          >
            {isSubmitting && <span className="module-button-spinner" />}
            {isSubmitting ? "Menyimpan..." : "Tambahkan"}
          </button>
        </div>
      </form>
    </Modal>
  );
}
